import { css } from '@emotion/react'
import { IPartnerLanding } from 'api/contentful/contentful.types'
import { Block } from 'components/Block'
import { ColumnBlock } from 'components/Column'
import { SLeftContent, SLeftDiv, SPartnerBenefits, SRightDiv } from './PartnerBenefits.styled'
import { PartnerLogos } from 'components/content/partners/PartnerLogos'
import { Icon } from 'components/icon'
import { Spacer } from 'components/spacer/Spacer'
import { Stack } from 'components/Stack'
import { StepList } from 'components/stepList/StepList'
import { Caption, Title, Title_h3_default } from 'components/Typography'
import { ReactNode } from 'react'
import { colors } from 'utils/colors'
import { pxToRem } from 'utils/styled'
import { ApiType } from 'utils/types'

export function PartnerBenefits(props: {
  className?: string
  promocode?: ApiType['PromoCodeResponse']
  partnerLandingCms?: IPartnerLanding
  children?: ReactNode
}) {
  return (
    <Block className={props.className} css={{ overflow: 'hidden' }}>
      <SPartnerBenefits>
        <SLeftDiv>
          <SLeftContent>
            <Caption
              css={css`
                color: var(--c-blue500);
                margin-bottom: 1.1875rem;
              `}
            >
              {props?.partnerLandingCms?.benefitsIntro}
            </Caption>

            <Title variant={Title_h3_default}>{props?.partnerLandingCms?.benefitsTitle}</Title>

            <Spacer size={[1.5, 3.25]} />

            {props.children}
          </SLeftContent>
        </SLeftDiv>

        <SRightDiv>
          <ColumnBlock>
            <StepList
              css={css`
                & > *:not(:last-child) {
                  margin-bottom: 1rem;
                }
              `}
              icon={<Icon name="Check" color={colors.blue[500]} size="1rem" />}
              items={props?.partnerLandingCms?.benefitsCollection?.items?.map((item) => (
                <Stack as="span" css={{ maxWidth: `${pxToRem(420)}rem` }} key={item.sys?.id}>
                  <strong>{item.title}</strong>
                  <span css={{ color: 'var(--c-gray500)' }}>{item.description}</span>
                </Stack>
              ))}
            />
            <PartnerLogos css={{ marginTop: '2rem' }} promocode={props.promocode} />
          </ColumnBlock>
        </SRightDiv>
      </SPartnerBenefits>
    </Block>
  )
}
